import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiCalls from '~/helpers/apiCalls';
import useWorkflowProps from './useWorkflowProps';


type UseCreateTagOptions = {
  tagName: string;
  tagColor: string;
};

async function createTag(payload: UseCreateTagOptions) {
  return apiCalls.settings.createTag({
    tag: {
      categoryId: null,
      ...payload,
    },
  });
}

function useCreateTag() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UseCreateTagOptions) => createTag(payload),
    /**
     * returning the result of .invalidateQueries will keep the status of this mutation as
     * "loading" (`isLoading` would be `true) until the invalidated query is updated
     */
    onSuccess: () => queryClient.invalidateQueries(
      useWorkflowProps.getQueryKey(),
    ),
  });
}

export default useCreateTag;
